import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import env from "../../env/src_config";
import {create_datatable} from "../../izUtils";
import { withRouter } from 'react-router-dom';
import axios from "axios";
import ReactGA from 'react-ga4';
import axiosErrorResponse from '../../hoc/AxiosErrorResponse/AxiosErrorResponse';

import ListElement from "../ActiveList/ListElement/ListElement";
import Breadcrumb from "../../hoc/Header/Breadcrumbs/Breadcrumb";

import './CancelList.css';
import Loading from "../../hoc/Loading/Loading";
import {connect} from 'react-redux';
import {BidderLink} from "../CommonFunctions/BidderLink";

class CancelList extends Component {
    state = {
        listElements: null,
        bidderSubmitIds: []
    }

    datatable = null;
    postData = null;

    componentDidMount() {
        console.log('Global jQuery:', !!window.$);
        console.log('DataTable exists:', !!window.$?.fn?.DataTable);

        this.reactGa();
        this.reloadeState();
    }

    reactGa = () => {
        if (this.props.initializedGA) {
            ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { t } = this.props;
        let dataTableRows = 25;
        const lsData = JSON.parse(localStorage.getItem('SODNEDRAZBE.filterDisplay'));

        if (lsData!== undefined && lsData !== null && lsData.pagination.limit !== undefined) {
            dataTableRows = lsData.pagination.limit
        }

        if (typeof $ !== 'undefined' && $.fn && $.fn.DataTable) {
            if ( ! $.fn.DataTable.isDataTable( '#CancelList' ) ) {
                this.datatable = create_datatable(t, 'CancelList', null, undefined, [ 6, "desc" ], dataTableRows);
            }

            // when DataTable changes (row count or pagination)
            $('#CancelList').DataTable().on( 'draw', function (e, settings) {
                if (lsData !== undefined) {
                    lsData.pagination.limit = settings._iDisplayLength;
                    localStorage.setItem('SODNEDRAZBE.filterDisplay', JSON.stringify(lsData));
                }
            } );
        }

        if (this.props.match.path !== prevProps.match.path) {
            this.reloadeState();
        }

        if ((this.props.initializedGA !== prevProps.initializedGA) && this.props.initializedGA) {
            this.reactGa();
        }
    }

    reloadeState() {
        this.reloadList();
    }

    reloadList = () => {
        axios.post(env.api.public + 'publication/rootlist', {"type":"canceled"}, this.props.options.postHeaders).then((response) => {
            if (response.status === 200) {

                if (this.datatable !== null) {
                    this.datatable.destroy();
                }

                let list = [];
                if (response.data.list.length !== 0) {
                    for(let i = 0; i < response.data.list.length; i++) {
                        list.push(response.data.list[i]);
                    }
                }

                this.setState({listElements: list});
            }
        }, (error) => {
            axiosErrorResponse(error);
            console.log(error);
        });
    }

    /* Handlers */
    showSinglePublishedHandler = (listElement) => {
        this.props.history.push({ pathname: BidderLink(this.props.options, this.state.bidderSubmitIds, listElement)});
    }
    /* END: Handlers */

    render() {
        if (this.state.listElements !== null) {
            const { t } = this.props;
            let tableElements = this.state.listElements.map(listElement => {
                return (
                    <ListElement
                        key={listElement.id}
                        element={listElement}
                        showSinglePublished={() => this.showSinglePublishedHandler(listElement)}
                        t={t}
                    />
                );
            });

            let title = t('cancel.title');

            return (
                <Fragment>
                    <Breadcrumb title={title} />

                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title mb-2">{title}</h4>

                                    {this.state.listElements.length ?
                                        <table id="CancelList" className="table table-bordered" style={{width:"100%"}}>
                                            <thead>
                                            <tr>
                                                <th/>
                                                <th>{t('published.list.tableH.publishId')}</th>
                                                <th>{t('published.list.tableH.matter')}</th>
                                                <th>{t('published.list.tableH.status')}</th>
                                                <th>{t('draft.list.tableH.procedureType')}</th>
                                                <th>{t('draft.list.tableH.saleMethod')}</th>
                                                <th>{t('published.list.tableH.publishedDate')}</th>
                                                <th>{t('draft.list.tableH.startDate')}</th>
                                                <th>{t('draft.list.tableH.endDate')}</th>
                                                <th>{t('draft.list.tableH.saleForm')}</th>
                                            </tr>
                                            </thead>
                                            <tbody>{tableElements}</tbody>
                                        </table>
                                        :
                                        <div>{t('listIsEmpty')}</div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                </Fragment>
            );
        } else {
            return (<Loading />);
        }
    }
}

const mapStateToProps = state => {
    return {
        options: state.options,
        initializedGA: state.initializedGA
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setBidderIds: (array) => dispatch({type: 'SETBIDDERIDS', value: array}),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(CancelList)));
